import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
export function Input({
  label,
  error,
  className = '',
  id,
  ...props
}: InputProps) {
  const inputId = id || props.name;
  return <div className="w-full" data-id="element-182">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-slate-700 mb-1" data-id="element-183">
          {label}
        </label>}
      <input id={inputId} className={`flex h-10 w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50 ${error ? 'border-red-500 focus:ring-red-500' : ''} ${className}`} {...props} data-id="element-184" />
      {error && <p className="mt-1 text-sm text-red-500" data-id="element-185">{error}</p>}
    </div>;
}